import { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";
import api from "@/lib/api";

export default function AnnouncementBanner() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dv_dismissed_ann") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    api.get("/announcements").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const visible = items.find((a) => !dismissed.includes(a.id));
  if (!visible) return null;

  const dismiss = () => {
    const next = [...dismissed, visible.id];
    setDismissed(next);
    localStorage.setItem("dv_dismissed_ann", JSON.stringify(next));
  };

  return (
    <div data-testid="announcement-banner" className="bg-gradient-primary text-white px-5 py-2.5 flex items-center justify-between gap-3 text-sm">
      <div className="flex items-center gap-2 min-w-0">
        <Megaphone className="w-4 h-4 shrink-0" />
        <span className="font-semibold truncate">{visible.title}:</span>
        <span className="text-white/90 truncate">{visible.body}</span>
      </div>
      <button data-testid="announcement-dismiss" onClick={dismiss} className="p-1 hover:bg-white/10 rounded shrink-0">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
